import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roi',
  component: () => import('../../routes/ROI.svelte'),
  card: {
    id: 'roi',
    title: 'ROI Calculator',
    description: 'Calculate the return on your investment portfolio to accurately track performance.',
    icon: 'percent',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/roi',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'ROI Calculator – Return on Investment Calculator',
    description: 'Free ROI calculator to calculate return on investment. Use our investment ROI calculator for rental property ROI, marketing ROI, and more. See the ROI calculation formula, annualized returns, and total profit instantly.',
  },
};

export default meta;
